import { createFileRoute } from '@tanstack/react-router'
import EmployeeDormitory from '@/features/employee-portal/pages/EmployeeDormitory'

export const Route = createFileRoute('/_authenticated/employee-portal/dormitory')({
  component: EmployeeDormitory,
})